import { render, staticRenderFns } from "./DisplayTests.vue?vue&type=template&id=9864acd0&scoped=true"
import script from "./DisplayTests.vue?vue&type=script&lang=js"
export * from "./DisplayTests.vue?vue&type=script&lang=js"
import style0 from "./DisplayTests.vue?vue&type=style&index=0&id=9864acd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864acd0",
  null
  
)

export default component.exports